import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { pageview } from '../utils/analytics.js';

const Page = forwardRef((_a, ref) => {
    var { title, children } = _a, rest = __rest(_a, ["title", "children"]);
    const location = useLocation();
    const sendPageViewEvent = useCallback(() => {
        pageview({
            page_path: location.pathname,
        });
    }, [location]);
    useEffect(() => {
        sendPageViewEvent();
    }, [sendPageViewEvent]);
    return (
    // @ts-ignore
    jsxs("div", Object.assign({ ref: ref }, rest, { children: [jsx(Helmet, { children: jsx("title", { children: title }) }), children] })));
});

export { Page };
